import { ReactElement } from "react";
import { Modal } from "antd";
import CustomForm, { ICustomForm } from "../CustomForm";

type IModalForm<T, Q> = {
  isOpen: boolean;
  modalTitle: string;
  maskClosable?: boolean;
} & ICustomForm<T, Q>;

function ModalForm<T, Q>({
  isOpen,
  modalTitle,
  formName,
  formItems,
  maskClosable = true,
  handleCancel,
  handleOk,
  okApi,
}: IModalForm<T, Q>): ReactElement {

  return (
    <Modal
      title={modalTitle}
      open={isOpen}
      footer={null}
      onCancel={handleCancel}
      maskClosable={maskClosable}
      destroyOnClose
    >
      <CustomForm formName={formName} formItems={formItems} handleCancel={handleCancel} handleOk={handleOk} okApi={okApi} />
    </Modal>
  );
}

export default ModalForm;
